import { useMountEffect } from '@direct-frontend/stdlib';
import { useCallback, useState } from 'react';

/**
 * Управляет состоянием раскрытия аккордеонов узлов
 */
export function useExpandedState(initialExpandedIds: string[], forcedExpandedIds?: ReadonlySet<string>) {
    const [expandedTreeNodes, setExpandedTreeNodes] = useState(new Set<string>());

    useMountEffect(() => {
        setExpandedTreeNodes(expandedTreeNodes => {
            const newExpandedTreeNodes = new Set(expandedTreeNodes);
            initialExpandedIds.forEach(id => newExpandedTreeNodes.add(id));

            return newExpandedTreeNodes;
        });
    });

    const setExpanded = useCallback((itemId: string, expanded: boolean) => {
        setExpandedTreeNodes(expandedTreeNodes => {
            const newExpandedTreeNodes = new Set(expandedTreeNodes);
            if (expanded) {
                newExpandedTreeNodes.add(itemId);
            } else {
                newExpandedTreeNodes.delete(itemId);
            }

            return newExpandedTreeNodes;
        });
    }, []);

    function getNodeIsExpanded(itemId: string) {
        if (expandedTreeNodes.has(itemId)) return true;
        return forcedExpandedIds?.has(itemId) === true;
    }

    const collapseAll = useCallback(() => {
        setExpandedTreeNodes(new Set());
    }, [setExpandedTreeNodes]);

    return { getNodeIsExpanded, setExpanded, collapseAll } as const;
}
